import React from 'react';
import { Col, Row} from "reactstrap";
import warningIcon from '../../../assets/warning.svg';
import '../Message.css';
const warningMessage = (props) => (
    <Row className="review-warning-msg-bg" style={{ marginLeft: '0px', marginRight: '0px' }}>
        <Col sm={1} md={1} style={{ paddingRight: '0px' }}>
          <span><img src={warningIcon} className="warning-i"/></span>
        </Col>
        <Col sm={11} md={11} className="warning-msg-ml-5">
          <Row><span className="warning-msg-text">{(props) ? props.msg : ''}</span></Row>
          <Row><span className="warning-msg-sub-text">{(props) ? props.subMsg : ''}</span></Row>
        </Col>
      </Row>)

 export default warningMessage;
